import { intl } from "LocaleWrapper";
import { SailingReportRangeType } from "view/sailingreports/utils/SailingReportUtils";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { getPluginSettingValue } from "components/utils/Permission";
import { useStoreState } from "ezStore";

const SailingReportTypeSelect = (props: Omit<SelectProps<SailingReportRangeType, false>, "fetchOptions" | "paginated" | "disableSearch">) => {

	const session = useStoreState(store => store.session);

	const pluginRangeType = getPluginSettingValue(session, "sailingReportRangeType") as Exclude<SailingReportRangeType, SailingReportRangeType.Voyage> | undefined;

	return (
		<Select
			fetchOptions={[
				SailingReportRangeType.Voyage,
				pluginRangeType ?? SailingReportRangeType.Date,
			]}
			getOptionLabel={option => intl.formatMessage({ id: option })}
			clearable={false}
			disableSearch
			{...props}
		/>
	);
};

export default SailingReportTypeSelect;
